import { callPutApi, callPostApi, callGetApi } from "./api";
import { uploadImageFromFormData } from "../Helpers/uploadViaPresign";


export async function getFeaturedProduct(id, moduleName) {
      // return this.interceptors.GET(`featured-product/${moduleName}/${id}/${false}`);
      try {
            const response = await callGetApi({ url: `featured-product/${moduleName}/${id}/${false}` });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function uploadImage(data) {
      // data is FormData with an "image" field (legacy multipart shape).
      // Routed through api-v2 presign + direct-to-S3 PUT; response shape
      // matches the legacy multipart envelope so consumers don't change.
      try {
            return await uploadImageFromFormData(data);
      } catch (error) {
            throw error;
      }
}

export async function updateStatus(postData) {
      // return this.interceptors.PUT("utils/update-status/", postData);
      try {
            const response = await callPutApi({ url: "utils/update-status/", body: postData });
            return response;
      } catch (error) {
            throw error;
      }
}
